export const instantSearchPostMarkUp = {
  render: function(data) {
    return data.map(item => `
      <article class="instant-search-post" id="post-${item.id}">
        ${item.featured_media_post}
        <div class="instant-search-post__content">
          <span class="instant-search-post__title">${item.title}</span>
          <p class="instant-search-post__excerpt">${item.excerpt_post}</p>
        </div>

        <div class="instant-search-post__link-wrp">
          <a class="instant-search-post__link Btn" href="${item.url}" class="instant-search-post__link" title="Ler mais sobre ${item.title}">Ler Mais</a>
        </div>
      </article>
    `)
  },
  renderMobile: function(data) {
    return data.map(item => `
      <article class="instant-search-post-mobile" id="post-${item.id}">
        <div class="instant-search-post-mobile__content">
          <div class="instant-search-post-mobile__img-wrp">
            ${item.featured_media_post}
          </div>

          <div class="instant-search-post-mobile__text-wrp">
            <span class="instant-search-post-mobile__title">${item.title}</span>
            <div class="instant-search-post-mobile__link-wrp">
              <a class="instant-search-post-mobile__link Btn" href="${item.url} title="Ler mais sobre ${item.title}">Ler Mais</a>
            </div
          </div>
        </div>
      </article>
    `)
  }
}
